import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer';

import { Html } from 'react-pdf-html';
import Roboto from '../../assets/fonts/Roboto-Regular.ttf'
import RobotoBold from '../../assets/fonts/Roboto-Bold.ttf'
import RobotoItalic from '../../assets/fonts/Roboto-Italic.ttf'
import {testImage} from './mockImage'

Font.register({
  family: 'Roboto',
  fonts: [
    { src: Roboto },
    {
      src: RobotoBold,
      fontWeight: 800,
    },
    {
      src: RobotoItalic,
      fontStyle: 'italic'
    },
  ],
});

const styles = StyleSheet.create({
  body: {
    paddingTop: 37,
    paddingBottom: 50,
    paddingHorizontal: 40,
  },
  header: {
    position: 'absolute',
    top: 5,
    left: 20,
    right: 20,
    alignItems: 'center'
  },
  ceaheader: {
    marginBottom: 3,
  },
  ceasubheader: {
    fontSize: 5,
    marginBottom: 2,
    border: 0,
    borderWidth: 0,
    alignSelf: 'flex-end',
    width: '30%',
    textAlign: 'center',
  },
  table: {
    width: '30%',
    border: '1px',
    alignSelf: 'flex-end',
    fontSize: 7,
    fontWeight: 800,
    fontFamily: 'Helvetica-Bold'
  },
  row: {
    flexDirection: 'row',
  },
  cell: {
    flex: 1,
    padding: 3,
    textAlign: 'center',
    borderWidth: 1,
    borderColor: 'black',
  },
  footer: {
    flexDirection: 'row', // Align items horizontally
    alignItems: 'center', // Center items vertically
    position: 'absolute',
    bottom: 5,
    left: 25,
    right: 25,
  },
  textFooter: {
    flex: 1, // Allow the text to expand
    marginLeft: 10, // Adjust margin for spacing
    fontSize: 7,
    fontWeight: 'bold',
    maxWidth: 230,
  },
  footerImages: {
    flexDirection: 'row', // Align images horizontally
    alignItems: 'center', // Center items vertically
    marginLeft: 10, // Adjust margin for spacing
  },
  imgFooter: {
    height: 45,
    width: 55,
    marginLeft: 15, // Adjust margin for spacing between images
  },
  image: {
    height: 37,
    width: 124
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 8,
    bottom: 50,
    left: 0,
    right: 60,
    textAlign: 'right',
  },
  subFooter: {
    position: 'absolute',
    fontSize: 8,
    bottom: 50,
    left: 50,
    right: 50,
    textAlign: 'center',
    border: '1px',
    alignItems: 'center',
  },
  signatureImage: {
    height: 25,
    width: 75
  },
});

const MyDocument = ({
  fileName,
  template,
  header,
  footer,
  formData = {},
  mainData = {},
  agentData={},
  signatoryData = {}
}) => {

  // Function to replace placeholders in a string using values from an object
  function replaceTemplate(str, obj) {
    return str.replace(/{([^{}\s]+)}/g, (match, p1) => {
      const keys = p1.split('.'); // Split keys if nested object access is needed
      let value = obj;
      for (let key of keys) {
        value = value[key];
        if(key.includes('Signature')){
          if(!value || value === undefined) return '#'
        }else {
          if (value === undefined) return match; // If key not found, return original match
        }
      }
      return value;
    });
  }
  
  const replaceWithSignature = replaceTemplate(template, signatoryData);
  const replacedWithFormVals = replaceTemplate(replaceWithSignature, formData);
  const replaceWithMainVals = replaceTemplate(replacedWithFormVals, mainData);
  const replaceWithAgentDetails = replaceTemplate(replaceWithMainVals, agentData);
  const finalTemplate = replaceWithAgentDetails.replace(/{([^{}\s]+)}/g, ""); //to remove all the non-existing {variable}


  const HeaderLogo = () => {
    if (header === "Yes" || header === true) {
      return (
        <View style={styles.header} fixed>
          <Image
            style={styles.image}
            src={process.env.PUBLIC_URL + '/assets/image/realstar.png'}
          />
        </View>
      )
    }
    else {
      return null
    }
  };

  const Footer = () => {
    if (footer === "Yes" || footer === true) {
      return (
        <>
          <View style={styles.footer} fixed>
            <Image
              style={styles.image}
              src={process.env.PUBLIC_URL + '/assets/image/realstar.png'}
            />
            <Text style={styles.textFooter}>
              L3008563G  {'\n'}
              Realstar Premier Group Pte Ltd 186 Bukit Timah Road Singapore 229855 {'\n'}
              Tel: +65 6447 1188 Fax:+65 6258 7588 www.realstarpremier.com
            </Text>
            <View style={styles.footerImages}>
              <Image
                style={styles.imgFooter}
                src={process.env.PUBLIC_URL + '/assets/image/award1.png'}
              />
              <Image
                style={styles.imgFooter}
                src={process.env.PUBLIC_URL + '/assets/image/award2.png'}
              />
            </View>
          </View>
        </>
      )
    }
    else {
      return null
    }
  };

  const CEASubHeaderAndFooter = () => {
    if(fileName?.toLowerCase().includes("cea form")){
      //for CEA FORM only
      const formNumber = fileName.match(/CEA FORM (\d+)/)?.[1];

      const formMapping = {
        1: {
          signedBy: 'Seller',
          confirmedBy: 'Seller(s)',
          signedBySignature: signatoryData.seller1NameSignature || '#'
        },
        2: {
          signedBy: 'Buyer',
          confirmedBy: 'Seller(s)',
          signedBySignature: signatoryData.buyer1NameSignature || '#'
        },
        3: {
          signedBy: 'Landlord',
          confirmedBy: 'Landlord(s)',
          signedBySignature: '#'
        },
        4: {
          signedBy: 'Tenant',
          confirmedBy: 'Landlord(s)',
          signedBySignature: '#'
        },
        5: {
          signedBy: 'Seller',
          confirmedBy: 'Landlord(s)',
          signedBySignature: signatoryData.seller1NameSignature || '#'
        },
        6: {
          signedBy: 'Buyer',
          confirmedBy: 'Landlord(s)',
          signedBySignature: signatoryData.buyer1NameSignature || '#'
        },
        7: {
          signedBy: 'Landlord',
          confirmedBy: 'Landlord(s)',
          signedBySignature: '#'
        },
        8: {
          signedBy: 'Tenant',
          confirmedBy: 'Landlord(s)',
          signedBySignature: '#'
        },
      }

      const {signedBy , confirmedBy , signedBySignature } = formMapping[formNumber] || { signedBy: '', confirmedBy: '' , signedBySignature: '#' } ;
      const agentSignature = signatoryData.agentNameSignature || "#"

    return (
      <>
        <View style={styles.ceaheader} fixed>
          <View style={styles.table}>
            <View style={styles.row}>
              <Text style={styles.cell}>Initials</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.cell}>{signedBy}</Text>
              <Text style={styles.cell}>Salesperson</Text>
            </View>
            <View style={styles.row}>
              <View style={styles.cell} fixed>
                  <Image
                    style={styles.signatureImage}
                    src={signedBySignature}
                  />
              </View>
              <View style={styles.cell} fixed>
                  <Image
                    style={styles.signatureImage}
                    src={agentSignature}
                  />
              </View>
            </View>
          </View>
        </View>
        <Text style={styles.ceasubheader} fixed>
          {confirmedBy} confirm that the deletion(s)
          herein were made in his/their presence
        </Text>

        <Text style={styles.subFooter} render={() => (
          `Council for Estate Agencies, Singapore | Prescribed Estate Agency Agreement: Form ${formNumber}`
        )} fixed />
        <Text style={styles.pageNumber} render={({ pageNumber }) => (
          `Page ${pageNumber} `
        )} fixed />
      </>
    )
  }else{
    return null;
  }

  }


  return (
    <Document>
      <Page size="A4" style={styles.body}>
        <CEASubHeaderAndFooter />{/* for CEA form only */}
        <HeaderLogo />
        <div>
          <Html>{finalTemplate}</Html>
        </div>
        <Footer />

      </Page>
    </Document>
  )
}

export default MyDocument;


